(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["buyback-form"] && !Shopify.designMode) return;
  try {
    
  /**
   * Wählt das Anliegen (Ankauf / Nur bewerten lassen) vor: aus dem URL-Parameter „anliegen“ beim Laden und
   * per Klick auf Links mit data-buyback-intent, die auf diese Seite zeigen (ohne Neuladen, sanftes Scrollen).
   */
  class BuybackForm extends HTMLElement {
    #onClick = (event) => this.#handleClick(event);

    connectedCallback() {
      /** @type {HTMLSelectElement | null} */
      this.select = this.querySelector('[data-buyback-select]');
      const intent = new URL(window.location.href).searchParams.get('anliegen');
      if (intent) this.#selectIntent(intent);
      document.addEventListener('click', this.#onClick);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.#onClick);
    }

    /**
     * @param {string} intent - ankauf | bewertung
     * @returns {boolean} true, wenn eine passende Option gesetzt wurde
     */
    #selectIntent(intent) {
      if (!this.select) return false;
      for (const option of this.select.options) {
        if (option.dataset.intent !== intent) continue;
        this.select.value = option.value;
        this.select.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
      return false;
    }

    /** @param {MouseEvent} event */
    #handleClick(event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey) return;
      const link = event.target instanceof Element ? event.target.closest('a[data-buyback-intent]') : null;
      if (!link) return;
      const url = new URL(link.href, window.location.href);
      if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;
      if (!this.#selectIntent(link.dataset.buybackIntent || '')) return;

      event.preventDefault();
      history.replaceState(history.state, '', url);
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      this.select?.focus({ preventScroll: true });
    }
  }

  if (!customElements.get('buyback-form')) customElements.define('buyback-form', BuybackForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /**
   * Hauptnavigation: Dropdowns/Mega-Menü öffnen per Hover/Fokus (CSS). Hier nur Tastatur und Zustand:
   * aria-expanded am Hauptpunkt, Esc schließt (Fokus zurück auf den Hauptpunkt), Pfeil runter öffnet und springt zum ersten Unterpunkt.
   */
  class HeaderNav extends HTMLElement {
    connectedCallback() {
      for (const item of this.querySelectorAll('[data-nav-item]')) {
        const trigger = item.querySelector(':scope > .header-nav__link');
        if (!trigger) continue;
        const panel = document.getElementById(trigger.getAttribute('aria-controls'));
        const expand = (open) => trigger.setAttribute('aria-expanded', String(open));
        const reset = () => { item.classList.remove('is-dismissed'); expand(false); };
        item.addEventListener('mouseenter', () => { item.classList.remove('is-dismissed'); expand(true); });
        item.addEventListener('mouseleave', () => { if (!item.contains(document.activeElement)) reset(); });
        item.addEventListener('focusin', () => { if (!item.classList.contains('is-dismissed')) expand(true); });
        item.addEventListener('focusout', (event) => { if (!item.contains(event.relatedTarget)) reset(); });
        item.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && trigger.getAttribute('aria-expanded') === 'true') {
            event.preventDefault();
            item.classList.add('is-dismissed');
            expand(false);
            trigger.focus();
          } else if (event.key === 'ArrowDown' && event.target === trigger) {
            event.preventDefault();
            item.classList.remove('is-dismissed');
            expand(true);
            panel?.querySelector('a')?.focus();
          }
        });
      }
    }
  }
  if (!customElements.get('header-nav')) customElements.define('header-nav', HeaderNav);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-pack"] && !Shopify.designMode) return;
  try {
    
  /**
   * Parallax-Neigung der Hero-Bühne: setzt --px/--py (-1 … 1) relativ zur Section.
   * Nur bei Maus/Trackpad und ohne „Bewegung reduzieren“; ein rAF je Frame.
   */
  class HeroPackScene extends HTMLElement {
    #frame = 0;
    #host = null;

    connectedCallback() {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
      if (reduced.matches || !fine.matches) return;
      this.#host = this.closest('[data-hero-pack]') ?? this;
      this.#host.addEventListener('pointermove', this.#onMove);
      this.#host.addEventListener('pointerleave', this.#onLeave);
    }

    disconnectedCallback() {
      this.#host?.removeEventListener('pointermove', this.#onMove);
      this.#host?.removeEventListener('pointerleave', this.#onLeave);
      cancelAnimationFrame(this.#frame);
    }

    /** @param {PointerEvent} event */
    #onMove = (event) => {
      const rect = this.#host.getBoundingClientRect();
      const x = ((event.clientX - rect.left) / rect.width - 0.5) * 2;
      const y = ((event.clientY - rect.top) / rect.height - 0.5) * 2;
      cancelAnimationFrame(this.#frame);
      this.#frame = requestAnimationFrame(() => this.#apply(x, y));
    };

    #onLeave = () => {
      cancelAnimationFrame(this.#frame);
      this.#apply(0, 0);
    };

    /** @param {number} x @param {number} y */
    #apply(x, y) {
      this.#host.style.setProperty('--px', x.toFixed(3));
      this.#host.style.setProperty('--py', y.toFixed(3));
    }
  }

  if (!customElements.get('hero-pack-scene')) customElements.define('hero-pack-scene', HeroPackScene);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  /**
   * Warenkorb-Seite: Mengen ändern und Entfernen per AJAX, Bestellnotiz automatisch speichern.
   * Ohne JS greift das normale Formular. Hört auf „cart:updated“ von außen (z. B. Drawer) und lädt sich dann neu.
   */
  class MainCart extends HTMLElement {
    /** @type {Map<number, number>} Entprell-Timer je Zeile */
    #timers = new Map();
    #ownEvent = false;
    #controller = null;

    connectedCallback() {
      this.addEventListener('change', this.#onChange);
      this.addEventListener('click', this.#onClick);
      document.addEventListener('cart:updated', this.#onExternalUpdate);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.#onChange);
      this.removeEventListener('click', this.#onClick);
      document.removeEventListener('cart:updated', this.#onExternalUpdate);
      this.#controller?.abort();
    }

    get #routes() {
      return window.theme?.routes ?? { cart_change_url: '/cart/change', cart_update_url: '/cart/update', cart_url: '/cart' };
    }

    #onChange = (event) => {
      const target = event.target;
      if (target.matches('[data-cart-note]')) {
        this.#saveNote(target.value);
        return;
      }
      if (!target.matches('[data-cart-line]')) return;
      const line = Number(target.dataset.cartLine);
      clearTimeout(this.#timers.get(line));
      this.#timers.set(line, setTimeout(() => this.#update(line, Math.max(0, Number(target.value) || 0)), 350));
    };

    #onClick = (event) => {
      const remove = event.target.closest('[data-cart-remove]');
      if (!remove) return;
      event.preventDefault();
      this.#update(Number(remove.dataset.cartRemove), 0);
    };

    /** Änderungen aus anderen Komponenten (Drawer, Schnellkauf): Section frisch laden. */
    #onExternalUpdate = async () => {
      if (this.#ownEvent || !window.PullEnergy) return;
      try {
        const doc = await window.PullEnergy.fetchSection(this.dataset.sectionId, this.#routes.cart_url);
        const source = doc.querySelector('#MainCartContent');
        const target = this.querySelector('#MainCartContent');
        if (source && target) target.replaceWith(source);
      } catch (error) {
        console.error(error);
      }
    };

    async #update(line, quantity) {
      const { applySections, bus, toast } = window.PullEnergy ?? {};
      const activeId = document.activeElement?.id;
      const errorBox = this.querySelector('[data-cart-error]');
      if (errorBox) errorBox.hidden = true;

      const hasDrawer = Boolean(document.querySelector('cart-drawer'));
      const sections = [this.dataset.sectionId, 'cart-icon-bubble'];
      if (hasDrawer) sections.push('cart-drawer');

      this.#controller?.abort();
      this.#controller = new AbortController();
      this.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(`${this.#routes.cart_change_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line, quantity, sections: sections.join(','), sections_url: window.location.pathname }),
          signal: this.#controller.signal,
        });
        const cart = await response.json();
        if (!response.ok) throw new Error(cart.description || cart.message);

        applySections?.(cart.sections, { [this.dataset.sectionId]: '#MainCartContent' });
        // Ohne Drawer übernimmt niemand den Zähler – dann selbst ersetzen
        if (!hasDrawer) applySections?.(cart.sections, { 'cart-icon-bubble': '#cart-icon-bubble' });
        this.#ownEvent = true;
        bus?.emit('cart:updated', { cart, sections: cart.sections });
        this.#ownEvent = false;

        this.#announce(this.dataset.msgUpdated);
        this.#restoreFocus(activeId);
      } catch (error) {
        if (error.name === 'AbortError') return;
        const message = error.message || window.theme?.strings?.cartError || '';
        // Mengen auf Serverstand zurücksetzen, dann Fehler zeigen
        await this.#onExternalUpdate();
        const box = this.querySelector('[data-cart-error]');
        if (box) {
          box.textContent = message;
          box.hidden = false;
        } else {
          toast?.(message);
        }
        this.#restoreFocus(activeId);
      } finally {
        this.removeAttribute('aria-busy');
      }
    }

    async #saveNote(note) {
      try {
        await fetch(`${this.#routes.cart_update_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note }),
        });
      } catch (error) {
        console.error(error);
      }
    }

    #restoreFocus(id) {
      const element = id ? document.getElementById(id) : null;
      if (element) {
        element.focus();
        return;
      }
      this.querySelector('[data-cart-heading]')?.focus();
    }

    #announce(message) {
      const region = document.getElementById('ThemeLiveRegion');
      if (!region || !message) return;
      region.textContent = '';
      requestAnimationFrame(() => {
        region.textContent = message;
      });
    }
  }

  if (!customElements.get('main-cart')) customElements.define('main-cart', MainCart);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-list-collections"]) return;
  try {
    
  /* Set-Suche: blendet Sets und leere Serien-Gruppen während der Eingabe aus */
  class SetFilter extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-set-filter-input]');
      this.input?.addEventListener('input', () => this.#filter());
    }

    #filter() {
      const query = this.input.value.trim().toLowerCase();
      let visible = 0;
      for (const group of this.querySelectorAll('[data-set-group]')) {
        let groupVisible = 0;
        for (const item of group.querySelectorAll('[data-set-name]')) {
          const match = !query || item.dataset.setName.includes(query);
          item.hidden = !match;
          if (match) groupVisible += 1;
        }
        group.hidden = groupVisible === 0;
        visible += groupVisible;
      }
      const empty = this.querySelector('[data-set-filter-empty]');
      if (empty) empty.hidden = visible > 0;
    }
  }
  customElements.define('set-filter', SetFilter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-password"]) return;
  try {
    
  /** Countdown bis zum Shop-Start (data-end = Unix-Zeit in Sekunden). */
  class LaunchCountdown extends HTMLElement {
    #timer = 0;

    connectedCallback() {
      this.end = Number(this.dataset.end) * 1000;
      this.values = {
        days: this.querySelector('[data-unit="days"]'),
        hours: this.querySelector('[data-unit="hours"]'),
        minutes: this.querySelector('[data-unit="minutes"]'),
        seconds: this.querySelector('[data-unit="seconds"]'),
      };
      this.#tick();
      this.#timer = window.setInterval(() => this.#tick(), 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.#timer);
    }

    #tick() {
      const left = Math.max(0, this.end - Date.now());
      const total = Math.floor(left / 1000);
      const parts = {
        days: Math.floor(total / 86400),
        hours: Math.floor((total % 86400) / 3600),
        minutes: Math.floor((total % 3600) / 60),
        seconds: total % 60,
      };
      for (const [unit, value] of Object.entries(parts)) {
        const el = this.values[unit];
        if (el) el.textContent = String(value).padStart(2, '0');
      }
      if (left > 0) return;
      window.clearInterval(this.#timer);
      const done = this.querySelector('[data-countdown-done]');
      if (done) done.hidden = false;
    }
  }

  if (!customElements.get('launch-countdown')) customElements.define('launch-countdown', LaunchCountdown);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  /**
   * Produktseite: Variantenwahl über Pills, URL-Update, Section-Rendering für Preis/Badges/Lager/Kartendaten,
   * mobile Kaufleiste. window.PullEnergy wird nur in Methoden genutzt (theme.js lädt als Modul verzögert).
   */
  class ProductInfo extends HTMLElement {
    #request = 0;
    #observer = null;

    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      const json = this.querySelector('[data-product-variants]');
      /** @type {{id: number, sku: string|null, margin: boolean, title: string, available: boolean, shipping: boolean, options: string[], media: number|null}[]} */
      this.variants = json ? JSON.parse(json.textContent) : [];
      this.idInput = this.querySelector('[data-variant-id]');
      // Mit JS übernimmt das versteckte Feld die Variante (ohne JS: <select name="id"> im <noscript>)
      if (this.idInput) this.idInput.name = 'id';
      this.addEventListener('change', this.#onChange);
      this.#refreshPills();
      this.#setupStickyBar();
      this.#setupStickyInfo();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.#onChange);
      this.#observer?.disconnect();
      this.#resize?.disconnect();
    }

    #resize = null;

    /** Infospalte: höher als das Fenster → Sticky-Abstand negativ, damit das Spaltenende erreichbar bleibt. */
    #setupStickyInfo() {
      const info = this.querySelector('.product__info');
      if (!info || !('ResizeObserver' in window)) return;
      const update = () => {
        const top = Math.min(112, window.innerHeight - info.offsetHeight - 24);
        info.style.setProperty('--info-top', `${top}px`);
      };
      this.#resize = new ResizeObserver(update);
      this.#resize.observe(info);
      window.addEventListener('resize', update, { passive: true });
    }

    /** Aktuell gewählte Optionswerte je Position. */
    #selected() {
      return Array.from(this.querySelectorAll('[data-option-position]'), (group) => group.querySelector('[data-option-input]:checked')?.value ?? null);
    }

    #onChange = (event) => {
      const input = event.target.closest('[data-option-input]');
      if (!input) return;
      const position = Number(input.closest('[data-option-position]').dataset.optionPosition);
      const selected = this.#selected();
      const variant = this.#resolve(selected, position);
      if (!variant) return;
      this.#check(variant.options);
      this.#refreshPills();
      this.#apply(variant);
    };

    /** Exakte Kombination, sonst die nächstbeste (verfügbar bevorzugt) mit dem geänderten Wert. */
    #resolve(selected, position) {
      const exact = this.variants.find((v) => v.options.every((value, i) => value === selected[i]));
      if (exact) return exact;
      const candidates = this.variants.filter((v) => v.options[position] === selected[position]);
      const score = (v) => v.options.reduce((sum, value, i) => sum + (value === selected[i] ? 1 : 0), 0) + (v.available ? 10 : 0);
      return candidates.sort((a, b) => score(b) - score(a))[0] ?? null;
    }

    #check(options) {
      for (const group of this.querySelectorAll('[data-option-position]')) {
        const value = options[Number(group.dataset.optionPosition)];
        for (const input of group.querySelectorAll('[data-option-input]')) input.checked = input.value === value;
        const label = group.querySelector('[data-option-selected]');
        if (label) label.textContent = value;
      }
    }

    /** Markiert je Wert: verfügbar / ausverkauft / Kombination existiert nicht (bezogen auf die übrigen Optionen). */
    #refreshPills() {
      if (!this.variants.length) return;
      const selected = this.#selected();
      for (const group of this.querySelectorAll('[data-option-position]')) {
        const position = Number(group.dataset.optionPosition);
        for (const input of group.querySelectorAll('[data-option-input]')) {
          const matches = this.variants.filter((v) => v.options[position] === input.value && v.options.every((value, i) => i === position || value === selected[i]));
          let state = 'missing';
          if (matches.some((v) => v.available)) state = 'available';
          else if (matches.length) state = 'soldout';
          const label = input.nextElementSibling;
          if (!label) continue;
          label.dataset.state = state;
          const status = label.querySelector('[data-pill-status]');
          if (status) status.textContent = state === 'available' ? '' : `, ${window.theme?.strings?.[state === 'soldout' ? 'soldOut' : 'unavailable'] ?? ''}`;
        }
      }
    }

    async #apply(variant) {
      if (this.idInput) this.idInput.value = String(variant.id);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', String(variant.id));
      window.history.replaceState({}, '', url);

      // Sofortige Rückmeldung am Button, bevor die Section nachgeladen ist
      const button = this.querySelector('[data-add-button]');
      if (button) {
        button.disabled = !variant.available;
        const label = button.querySelector('.product-form__label');
        const availableLabel = this.querySelector('template[data-add-label]');
        if (label && !variant.available) label.textContent = window.theme?.strings?.soldOut ?? '';
        else if (label && availableLabel) label.innerHTML = availableLabel.innerHTML;
      }
      const stockTemplate = this.querySelector(`template[data-stock-for="${variant.id}"]`);
      const stock = this.querySelector('[data-swap="inventory"] > .stock');
      const freshStock = stockTemplate?.content.querySelector('.stock');
      if (stock && freshStock) stock.replaceWith(freshStock.cloneNode(true));
      // Versand-Countdown nur für verfügbare Varianten mit Versand (Vorbestellungen rendern ihn gar nicht)
      const dispatch = this.querySelector('[data-dispatch-product]');
      if (dispatch) dispatch.hidden = !(variant.available && variant.shipping !== false);
      const stickyButton = this.querySelector('.sticky-buy__button');
      if (stickyButton) stickyButton.disabled = !variant.available;
      // Steuerhinweis sofort umschalten: § 25a-Variante → „Differenzbesteuert …“ statt „inkl. MwSt.“ (Section-Rendering bestätigt danach)
      for (const note of this.querySelectorAll('[data-swap="price"] [data-tax-note]')) {
        note.hidden = (note.dataset.taxNote === 'margin') !== Boolean(variant.margin);
      }

      if (variant.media) this.querySelector('product-gallery')?.showMedia(variant.media);
      window.PullEnergy?.bus.emit('variant:changed', { variant });

      const request = ++this.#request;
      try {
        const target = new URL(this.dataset.url, window.location.origin);
        target.searchParams.set('variant', String(variant.id));
        const doc = await window.PullEnergy?.fetchSection(this.sectionId, target.pathname + target.search);
        if (!doc || request !== this.#request) return;
        this.#swap(doc);
        const price = this.querySelector('[data-swap="price"] .price__current')?.textContent?.trim() ?? '';
        this.#announce(`${variant.title}${price ? ` – ${price}` : ''}`);
      } catch (error) {
        console.error(error);
      }
    }

    /** Ersetzt alle [data-swap]-Bereiche aus der neu gerenderten Section. */
    #swap(doc) {
      for (const current of this.querySelectorAll('[data-swap]')) {
        const fresh = doc.querySelector(`[data-swap="${current.dataset.swap}"]`);
        if (fresh) current.replaceWith(fresh);
      }
      const quantity = this.querySelector('[data-swap-max]');
      const freshQuantity = doc.querySelector('[data-swap-max]');
      if (quantity && freshQuantity) {
        const max = freshQuantity.getAttribute('max');
        if (max) {
          quantity.max = max;
          if (Number(quantity.value) > Number(max)) quantity.value = max;
        } else {
          quantity.removeAttribute('max');
        }
      }
    }

    #announce(message) {
      const region = document.getElementById('ThemeLiveRegion');
      if (!region) return;
      region.textContent = '';
      requestAnimationFrame(() => {
        region.textContent = message;
      });
    }

    /** Kaufleiste einblenden, sobald der Hauptbutton nach oben aus dem Bild gescrollt ist. */
    #setupStickyBar() {
      const bar = this.querySelector('[data-sticky-buy]');
      const anchor = this.querySelector('[data-buy-anchor]');
      if (!bar || !anchor || !('IntersectionObserver' in window)) return;
      this.#observer = new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.inert = !show;
      });
      this.#observer.observe(anchor);
    }
  }

  if (!customElements.get('product-info')) customElements.define('product-info', ProductInfo);

  /** Teilen: native Teilen-Funktion, sonst Link kopieren. Ohne JS: Link-Feld im <details>. */
  class ShareLink extends HTMLElement {
    connectedCallback() {
      this.summary = this.querySelector('summary');
      this.copyButton = this.querySelector('[data-share-copy]');
      if (this.copyButton && navigator.clipboard) this.copyButton.hidden = false;
      this.summary?.addEventListener('click', this.#onSummary);
      this.copyButton?.addEventListener('click', this.#onCopy);
    }

    #onSummary = async (event) => {
      if (!navigator.share) return;
      event.preventDefault();
      try {
        await navigator.share({ title: this.dataset.title, url: this.dataset.url });
      } catch (error) {
        if (error.name !== 'AbortError') console.error(error);
      }
    };

    #onCopy = async () => {
      try {
        await navigator.clipboard.writeText(this.dataset.url);
        window.PullEnergy?.toast(this.dataset.copied);
      } catch (error) {
        this.querySelector('[data-share-input]')?.select();
      }
    };
  }

  if (!customElements.get('share-link')) customElements.define('share-link', ShareLink);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  /** Lädt Empfehlungen nach, sobald die Section in die Nähe des Viewports kommt. */
  class ProductRecommendations extends HTMLElement {
    #observer = null;

    connectedCallback() {
      if (this.querySelector('.page-width')) return;
      if (!('IntersectionObserver' in window)) {
        this.#load();
        return;
      }
      this.#observer = new IntersectionObserver(
        ([entry]) => {
          if (!entry.isIntersecting) return;
          this.#observer.disconnect();
          this.#load();
        },
        { rootMargin: '0px 0px 400px 0px' }
      );
      this.#observer.observe(this);
    }

    disconnectedCallback() {
      this.#observer?.disconnect();
    }

    async #load() {
      try {
        const response = await fetch(this.dataset.url);
        if (!response.ok) return;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const fresh = doc.querySelector('product-recommendations');
        if (fresh?.querySelector('.page-width')) this.innerHTML = fresh.innerHTML;
      } catch (error) {
        console.error(error);
      }
    }
  }

  if (!customElements.get('product-recommendations')) customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pull-ticker"] && !Shopify.designMode) return;
  try {
    
  /** Pause-/Start-Knopf für das laufende Band (WCAG 2.2.2). */
  class PullTicker extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-ticker-toggle]');
      this.toggle?.addEventListener('click', this.#onToggle);
    }

    disconnectedCallback() {
      this.toggle?.removeEventListener('click', this.#onToggle);
    }

    #onToggle = () => {
      const paused = this.classList.toggle('is-paused');
      this.toggle.setAttribute('aria-pressed', String(paused));
    };
  }

  if (!customElements.get('pull-ticker')) customElements.define('pull-ticker', PullTicker);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["withdrawal-form"]) return;
  try {
    
  /* Mit Endpunkt der Warenwirtschaft: Widerruf per fetch senden (dort Speicherung + sofortige Eingangsbestätigung). */
  class WithdrawalForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.dataset.endpoint || !this.form) return;
      this.form.addEventListener('submit', this.#onSubmit);
    }

    #onSubmit = async (event) => {
      if (!this.form.reportValidity()) return;
      event.preventDefault();
      const button = this.form.querySelector('[type="submit"]');
      const error = this.querySelector('[data-withdrawal-error]');
      const limit = this.querySelector('[data-withdrawal-limit]');
      const data = Object.fromEntries(new FormData(this.form));
      button?.setAttribute('aria-busy', 'true');
      if (error) error.hidden = true;
      if (limit) limit.hidden = true;
      try {
        const response = await fetch(this.dataset.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            name: data['contact[name]'],
            email: data['contact[email]'],
            order_number: data['contact[Bestellnummer]'],
            order_date: data['contact[Bestelldatum]'] || null,
            items: data['contact[body]'] || null,
            shop: window.Shopify?.shop ?? null,
            locale: document.documentElement.lang,
            website: data.website || '',
          }),
        });
        if (response.status === 429) {
          if (limit) limit.hidden = false;
          return;
        }
        if (!response.ok) throw new Error(String(response.status));
        const result = await response.json().catch(() => ({}));
        this.#showDone(result);
      } catch {
        if (error) error.hidden = false;
      } finally {
        button?.removeAttribute('aria-busy');
      }
    };

    /* Bestätigung mit Eingangsnummer und -zeit; „pending“ = Mail noch nicht verschickt → neutraler Text */
    #showDone(result) {
      this.form.hidden = true;
      const done = this.querySelector('[data-withdrawal-done]');
      if (!done) return;
      if (result.reference) {
        done.querySelector('[data-withdrawal-reference]').textContent = result.reference;
        done.querySelector('[data-withdrawal-time]').textContent = result.received_at_local ?? result.received_at ?? '';
        done.querySelector('[data-withdrawal-receipt]').hidden = false;
      }
      const pending = result.confirmation_email === 'pending';
      done.querySelector('[data-withdrawal-mail-sent]').hidden = pending;
      done.querySelector('[data-withdrawal-mail-pending]').hidden = !pending;
      done.hidden = false;
      done.focus();
    }
  }
  customElements.define('withdrawal-form', WithdrawalForm);

  } catch(e) { console.error(e); }
})();
})();
